import * as React from "react";
import { PlayerView } from '../playerview';
import { PlayerWithSeekbarComponentCSSStyle } from './playerwithseekbarcss';
import './seekbarthumb.css';
import { UIComponentHandler } from '../../uicomponent';
import { BaseContext } from '../../../../utils/basecontext';
import { AudioPlayerWithSeekbar, AudioPlayerWithSeekbarImpl } from '../../../../utils/player/playerwithseekbar/audioplayerwithseekbarImpl';
import { AudioPlayerWithSeekbarHandler } from 'src/com/sixdee/crbtportal/utils/player/playerwithseekbar/audioplayerwithseekbarhandler';
import { PlayerComponentProps, PlayerComponentState, PlayerComponentHandler } from '../playercomponent';

export class PlayerWithSeekbarView extends PlayerView implements AudioPlayerWithSeekbarHandler {
   
    private startTime: HTMLLabelElement;
    private endTime: HTMLLabelElement;
    private audioPlayerWithSeekbar: AudioPlayerWithSeekbar;

    constructor(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler) {
        super(applicationContext, uiComponentHandler);

        this.audioPlayerWithSeekbar = new AudioPlayerWithSeekbarImpl(applicationContext.getPlayerManager().getAudioPlayer());
        this.audioPlayerWithSeekbar.setAudioPlayerWithSeekBarHandler(this);
    }

    bindHandlers() {
        this.onPlayClicked = this.onPlayClicked.bind(this);
        this.onStopClicked = this.onStopClicked.bind(this);
    }

    draw(uiProps: PlayerComponentProps, uiState: PlayerComponentState, cssStyle: PlayerWithSeekbarComponentCSSStyle): JSX.Element | boolean {
        super.draw(uiProps, uiState, cssStyle);

        return (
            <div style={cssStyle.getPlayDivCSSStyle()}>
                <div style={cssStyle.getStartTimePlayEndTimeDivCSSStyle()}>
                    <label style={cssStyle.getStartTimeCSSStyle()} ref={(item: any) => { this.startTime = item; }}>{this.updateStartTime}</label>
                        <label style={{marginLeft:'5px',marginRight:'5px',color:'#FFFFFF'}}>{"/"}</label>
                    <label style={cssStyle.getEndTimeCSSStyle()} ref={(item: any) => { this.endTime = item; }} >{this.updateEndTime}</label>

                    {
                        !uiState.isPlaying ?
                            <img onClick={this.onPlayClicked} style={cssStyle.getPlayIconCSSStyle()} src={uiProps.context.getResources().getImage(uiProps.playIconName)} />
                            :
                            <img onClick={this.onStopClicked} style={cssStyle.getPlayIconCSSStyle()} src={uiProps.context.getResources().getImage(uiProps.pauseIconName)} />
                    }
                </div>
                <input id="seek" className="slider" style={cssStyle.getSeekbarCSSStyle("0")} type={"range"} step={"1"} ref={(item: any) => { this.audioPlayerWithSeekbar.setSeekbar(item); }} onChange={this.audioPlayerWithSeekbar.changeCurrentTime}/>
            </div>);
    }

    updateSeekbarPlayedPartColor(percent: string): void 
    {
        let seekbarElement = document.getElementById('seek') as HTMLElement ;
        seekbarElement.style.background = "linear-gradient(to right, #D7006D 0%, #D7006D "+ percent +"%, #fff "+ percent +"%, #fff 100%)";
    }

    resetControls() {
        this.audioPlayerWithSeekbar.onReset();
    }

    unregisterAudioEvents() {
        this.audioPlayerWithSeekbar.unregisterAudioEvents();
    }

    getUIComponentHandler(): PlayerComponentHandler {
        return super.getUIComponentHandler() as PlayerComponentHandler;
    }

    getAudioPlayerWithSeekbar(): AudioPlayerWithSeekbar {
        return this.audioPlayerWithSeekbar;
    }

    updateStartTime(startTime: string): void 
    {
        if (this.startTime !== null) {
            this.startTime.innerHTML = startTime;
        }
    }
    updateEndTime(endTime: string): void {
        if (this.endTime !== null) {
            this.endTime.innerHTML = endTime;
        }
    }

    // updatePlayControlsRef(): void 
    // {
    //     this.audioPlayerWithSeekbar.setStartTimeRef(this.startTime);
    //     this.audioPlayerWithSeekbar.setEndTimeRef(this.endTime);
    // }

    /*  
    Added via base class
    private onPlayClicked(e: any)
     {
         e.stopPropagation();
         this.getUIComponentHandler().onPlayClicked();
     }
 
     private onStopClicked(e: any)
     {
         e.stopPropagation();
         this.getUIComponentHandler().onStopClicked();
     } */
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/player/playerwithseekbar/playerwithseekbarview.tsx